module.exports = __webpack_public_path__ + "img/xiaoyuan.82c64669.png";